import type { ProblemExecutorReviewResponse } from '@/core/generated/api';
import { formatDateTime } from '@/core/format';
import type { ColumnConfig } from '@/shared/ui/DataTable/DataTable';
import { ReviewReference } from '../ui/ReviewReference';
import classes from './problem-executor.module.scss';

/** Колонки отзывов с низкими оценками */
export const PROBLEM_EXECUTOR_COLUMNS: ColumnConfig<ProblemExecutorReviewResponse>[] = [
    {
        field: 'mark',
        header: 'Оценка клиента',
        body: row => <span
            className={classes.rating}
            role="img"
            aria-label={`${row.mark} из 5 звёзд`}
        >
            {row.mark} ★
        </span>,
    },
    {
        field: 'orderNumber',
        header: 'Заказ',
        body: row => <ReviewReference
            id={row.orderId}
            name={row.orderNumber
                ? `№ ${row.orderNumber}`
                : 'Без заказа'
            }
            section="orders"
            permission="admin.orders.view"
        />,
    },
    {
        field: 'executorName',
        header: 'Исполнитель',
        body: row => <ReviewReference
            id={row.executorId}
            name={`${row.executorName ?? ''} ${row.executorLastName ?? ''}`.trim() || 'Исполнитель не указан'}
            section="executors"
            permission="admin.executors.view"
        />,
    },
    {
        field: 'clientName',
        header: 'Клиент',
        body: row => <ReviewReference
            id={row.clientId}
            name={row.clientName || 'Клиент не указан'}
            section="clients"
            permission="admin.clients.view"
        />,
    },
    {
        field: 'description',
        header: 'Текст отзыва',
        body: row => <div className={classes.reviewText}>
            <span>{row.description?.trim()
                ? row.description
                : 'Без текста'}</span>
            {row.isShadow &&
                <small>Скрыт из публичных отзывов</small>
            }
        </div>,
        style: { minWidth: '18rem' },
    },
    {
        field: 'created',
        dataType: 'date',
        header: 'Дата отзыва (MSK)',
        body: row => formatDateTime(row.created, true),
    },
];

